/**
 * Het verslagjaar dat de schil in de kop toont (master-architectuur v4.0 §3:
 * verslagjaar, horizon en scenario permanent in beeld).
 *
 * Nog niet kiesbaar: de schermen rekenen elk met hun eigen constante 2026 en
 * vragen de API daarom. Zodra er een verslagjaarkeuze komt, wordt dit de bron
 * voor alle schermen in plaats van een tweede plek met hetzelfde getal.
 */
export const REPORTING_YEAR = 2026;
